import React, { Component, PureComponent, Fragment } from 'react'
import { Map, List, fromJS } from 'immutable'
import Form from './Form'
import Field from './Field'
import Submit from './Submit'
import Validator from '../Validator'

export default class SimpleForm extends Component {
  state = {
    formState: {
      errors: Map(),
      messages: List(),
      values: Map(),
      originalValues: Map(),
      changed: Map(),
      loading: false,
    },
  }

  constructor(props) {
    super(props)
    let { values } = props
    if (!Map.isMap(values) || !values.size) return

    this.state.formState.values = values
    this.state.formState.originalValues = values
  }

  formUpdate = e => {
    let { name, value } = e.target || e
    let { formState } = this.state
    let { onUpdate } = this.props
    formState.values = formState.values.setIn(name.split('.'), value)
    formState.changed = formState.changed.setIn(name.split('.'), value)

    if (typeof onUpdate === 'function') formState = onUpdate(name, value, formState)

    this.setState({ formState })
  }

  formInit = values => {
    if (!Map.isMap(values)) values = fromJS(values)

    this.setState({
      formState: {
        errors: Map(),
        messages: List(),
        values,
        originalValues: values,
        changed: Map(),
        loading: false,
      },
    })
  }

  formSetMeta

  handleSubmit = e => {
    e.preventDefault()
    e.stopPropagation()

    let { validation: formValidation = {}, onSubmit } = this.props
    let { formState } = this.state
    let { values, changed, meta } = formState
    let stateUpdate = {}
    let validation = false

    if (typeof formValidation === 'function') {
      validation = formValidation.call(this, values, changed, meta, context)
    } else if (typeof formValidation === 'object') {
      validation = formValidation
    }

    let errors = validation ? Validator(values, validation) : Map()

    if (!errors.size) {
      let submitReturn = onSubmit(values, changed, this.handleFormSubmitDone)

      // If submit handler returns a promise, call done at then
      if (submitReturn && typeof submitReturn.then === 'function')
        submitReturn.then(res => this.handleFormSubmitDone(res))

      stateUpdate.loading = true
    }

    formState.errors = errors
    stateUpdate.formState = formState
    this.setState(stateUpdate)
  }

  handleFormSubmitDone = resState => {
    if (typeof resState !== 'object') resState = {}

    let state = {}
    state.loading = false

    // Update errors map
    if (resState.errors) {
      resState.errorsMap = Map()
      for (let name in resState.errors) {
        let value = resState.errors[name]
        resState.errorsMap = resState.errorsMap.setIn(name.split('.'), value)
      }
    }

    // Set messages
    if (resState.message) {
      resState.messages = resState.messages || []
      resState.messages.push({
        type: 'error',
        text: resState.message,
      })
    }

    if (Array.isArray(resState.messages))
      state.messages = resState.messages.map(message =>
        typeof message === 'string' ? { type: 'error', text: message } : message
      )

    state.formState = Object.assign({}, this.state.formState, resState)
    this.setState(state)
  }

  render() {
    let { fields = [], submitText = 'Tallenna', prompt = false } = this.props

    let { formState } = this.state

    return (
      <Form onSubmit={this.handleSubmit} formState={formState}>
        <div className="simple-form-fields">
          {fields.map(
            (
              {
                label,
                inputLabel,
                type,
                name,
                options = [],
                referenceConfig = {},
                multiple = false,
                render,
                visible = true,
              },
              i
            ) => {
              if (typeof visible === 'function') visible = visible(formState)

              if (!visible) return null

              if (typeof render === 'function')
                return (
                  <div key={i} className="form-custom-render">
                    {render(formState, this.formUpdate)}
                  </div>
                )

              return (
                <Field
                  label={label}
                  inputLabel={inputLabel}
                  type={type}
                  name={name}
                  options={options}
                  referenceConfig={referenceConfig}
                  multiple={multiple}
                  key={name}
                  onChange={this.formUpdate}
                  formState={formState}
                />
              )
            }
          )}
        </div>
        <div className="simple-form-submit">
          <Submit content={submitText} prompt={prompt} color="green" />
        </div>
      </Form>
    )
  }
}
